var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPTypeCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.382,
    height: 20.537,
    viewBox: "0 0 27.382 20.537",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_44446",
    "data-name": "Path 44446",
    d: "M194.759,145.6h-15.4a3.427,3.427,0,0,0-3.423,3.423v1.711h-1.711a3.428,3.428,0,0,0-3.423,3.423v8.557a3.427,3.427,0,0,0,3.423,3.423h15.4a3.427,3.427,0,0,0,3.423-3.423V161h1.711a3.427,3.427,0,0,0,3.423-3.423v-8.557a3.427,3.427,0,0,0-3.423-3.423Zm-15.4,1.711h15.4a1.711,1.711,0,0,1,1.711,1.711H177.645A1.711,1.711,0,0,1,179.357,147.311Zm11.98,15.4a1.711,1.711,0,0,1-1.711,1.711h-15.4a1.711,1.711,0,0,1-1.711-1.711v-8.557a1.711,1.711,0,0,1,1.711-1.711h1.711v5.134A3.427,3.427,0,0,0,179.357,161h11.98Zm5.134-5.134a1.711,1.711,0,0,1-1.711,1.711h-15.4a1.711,1.711,0,0,1-1.711-1.711v-6.846h18.825Zm-17.114-.856a.858.858,0,0,1,.856-.856h3.423a.856.856,0,1,1,0,1.711h-3.423A.858.858,0,0,1,179.357,156.724Z",
    transform: "translate(-170.8 -145.6)",
    fill: "#300787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPTypeCard);
export default __webpack_public_path__ + "static/media/p_type_card.370dfb3db9ecc38f47f9d57715589f76.svg";
export { ForwardRef as ReactComponent };